import { connect } from 'react-redux';

import Links from '../components/Links';

export default connect(
  state => ({
    links: state.footer.sectionLinks,
  })
)(Links);
